<div class="tw-inline-flex tw-gap-2">
  <span *ngFor="let item of filteredItems; let last = last" bitBadge [badgeType]="badgeType">
    {{ item }}
    <span class="tw-sr-only" *ngIf="!last || isFiltered">, </span>
  </span>
  <span *ngIf="isFiltered" bitBadge [badgeType]="badgeType">
    {{ "plusNMore" | i18n : (items.length - filteredItems.length).toString() }}
  </span>
</div>
